import { useEffect, useState } from "react";
import { Users, Mail, FolderOpen } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate } from "./constants";

export default function AdminClients() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/clients").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-clients-page" className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-[#0A192F]">Clienti</h1>
        <p className="mt-1 text-slate-600">Elenco dei clienti registrati.</p>
      </div>

      {items === null ? (
        <div className="py-20 text-center text-slate-400">Caricamento...</div>
      ) : items.length === 0 ? (
        <div data-testid="admin-clients-empty" className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center">
          <Users className="mx-auto h-10 w-10 text-slate-300" />
          <p className="mt-4 text-slate-500">Nessun cliente registrato.</p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <div key={c.id} data-testid={`admin-client-${c.id}`} className="rounded-2xl border border-slate-200 bg-white p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#0A192F] font-display text-sm font-bold text-white">
                  {c.name?.charAt(0)?.toUpperCase() || "C"}
                </span>
                <div>
                  <p className="font-semibold text-[#0A192F]">{c.name}</p>
                  <p className="flex items-center gap-1 text-xs text-slate-500"><Mail className="h-3 w-3" /> {c.email}</p>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-4 text-sm">
                <span className="flex items-center gap-1.5 text-slate-600"><FolderOpen className="h-4 w-4 text-[#10B981]" /> {c.requests_count} richieste</span>
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${c.subscription?.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                  {c.subscription?.active ? "Piano attivo" : "Piano non attivo"}
                </span>
              </div>
              <p className="mt-3 text-xs text-slate-400">Registrato il {fmtDate(c.created_at)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
